import Link from '../../Link'
import { createUseStyles } from 'react-jss'
import {
  Col,
  Row,
  Button,
  ButtonVariation,
  Avatar,
  ButtonSize
} from 'UI'
import styles from './style'
import Text from '../text.json'
import SearchBar from 'components/common/Searchbar'
import {
  smallLogo
} from 'assets'
import { CatalogPath, HomePath, PricingPath, ProfilePath, WebinarsPath, CatalogLearningPathsPath } from 'navigation/Routes'
import CartLink from '../CartLink'
import { amazonBucket, ExternalAlphormPages, ProfileTypes, WebinarFeature } from 'constants/'
import { decorateUrl } from 'components/common/UTMscript'
import { useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import ReactivateModal from 'components/Profile/Subscription/ReactivateModal'
import { signin } from 'identity/userManager'
import { NameInitials } from 'UI/helpers'

const useStyles = createUseStyles(styles)

let lastScrollTop = window.scrollY || document.documentElement.scrollTop
let scrollDuration = 0
const scrollDurationThreshold = 30

export default ({
  isConnected,
  goToLink,
  photo,
  activeSubscription,
  startTrialOnboarding,
  profileType,
  setTrialState,
  isElligableForTrial,
  isFrance,
  topBarOpen,
  isB2bUser,
  AutoRenew,
  familyName,
  givenName,
  isAlgeria
}) => {
  const { pathname } = useLocation()
  const [show, setShow] = useState(true)
  const [open, setOpen] = useState(false)
  const handleScroll = (e) => {
    const step = window.scrollY || document.documentElement.scrollTop
    if (step > lastScrollTop) {
      scrollDuration++
      if (scrollDuration > scrollDurationThreshold) setShow(false)
    } else {
      scrollDuration = 0
      setShow(true)
    }
    lastScrollTop = step <= 0 ? 0 : step
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  const { navbar, content, logo } = useStyles({ show, isFrance, isElligableForTrial, topBarOpen })
  const showReactivationButton = (profileType === ProfileTypes.PremiumSubscriber && !isB2bUser) && !AutoRenew
  return (
    <>
      <nav className={navbar} id='navbar'>
        <Row className={content} align='center'>
          <Col grid={6} mgrid={11} sgrid={11} pos='left' align='mid' gap={32} direction='row'>
            <a href={HomePath} onClick={e => e.preventDefault()}><img className={logo} src={smallLogo} alt='smallLogo' onClick={() => goToLink(HomePath)} width={50} height={50} /></a>
            <Link
              active={pathname.includes(CatalogPath)}
              title={Text.links.courses}
              margin='0 12px 0 0'
              dataTest='category-dropdown'
              path={CatalogPath}
              handleClick={() => goToLink(`${CatalogPath}`)}
            />
            <Link
              active={pathname.includes(CatalogLearningPathsPath)}
              title={Text.links.learningPaths}
              margin='0 12px 0 0'
              dataTest='category-dropdown'
              path={CatalogLearningPathsPath}
              handleClick={() => goToLink(`${CatalogLearningPathsPath}`)}
            />
            {
              WebinarFeature
                ? <Link
                    active={pathname.includes(WebinarsPath)}
                    title={Text.links.webinar}
                    margin='0 12px 0 0'
                    dataTest='category-dropdown'
                    path={CatalogPath}
                    handleClick={() => goToLink(WebinarsPath)}
                  />
                : null
            }
            <SearchBar />
          </Col>
          <Col grid={6} mgrid={7} sgrid={1} pos='right' align='mid' gap={32} direction='row'>
            {
              isConnected
                ? (
                  <>
                    <CartLink />
                    {
                      (!activeSubscription || profileType === ProfileTypes.BasicSubscriber)
                        ? (
                          <Link
                            active={pathname.includes(PricingPath)}
                            dataTest='pricing-page-link'
                            title={Text.links.pricing}
                            handleClick={() => goToLink(PricingPath)}
                            path={PricingPath}
                          />
                          )
                        : null
                    }
                    {
                      !activeSubscription
                        ? (
                          <>
                            <Link
                              title={Text.links.offers}
                              handleClick={() => window.open(decorateUrl(isAlgeria ? ExternalAlphormPages.AlgerianBusinessOffer : ExternalAlphormPages.BusinessOffer), '_blank')}
                              path={decorateUrl(isAlgeria ? ExternalAlphormPages.AlgerianBusinessOffer : ExternalAlphormPages.BusinessOffer)}
                            />
                            {
                              isFrance &&
                              (
                                <Link
                                  title={Text.links.funding}
                                  handleClick={() => window.open(decorateUrl(ExternalAlphormPages.Funding), '_blank')}
                                  path={decorateUrl(ExternalAlphormPages.Funding)}
                                />)
                            }
                          </>
                          )
                        : null
                    }
                    <Link
                      title={Text.links.blog}
                      handleClick={() => window.open(decorateUrl(ExternalAlphormPages.Blog), '_blank')}
                      path={decorateUrl(ExternalAlphormPages.Blog)}
                    />
                    <Link
                      active={pathname.includes(ProfilePath)}
                      title={Text.links.account}
                      handleClick={() => goToLink(ProfilePath)}
                      path={ProfilePath}
                      activeInit={pathname.includes(ProfilePath)}
                      dataTest='profile-link'
                      margin='0 -14px 0 0'
                    />
                    <Avatar
                      img={photo ? `${amazonBucket.bucketBaseUrl}${photo}` : null}
                      name={!photo ? NameInitials(`${givenName} ${familyName}`) : null}
                      handleClick={() => goToLink(ProfilePath)}
                      dataTest='profile-avatar'
                    />
                    {
                      isElligableForTrial && !activeSubscription
                        ? <Button
                            onHandleClick={() => {
                              setTrialState(true)
                              goToLink(HomePath)
                              startTrialOnboarding()
                            }}
                            variation={ButtonVariation.confirmation}
                            label={Text.buttons.signupTrial}
                            marginButton='0 8px'
                          />
                        : null
                    }
                    {
                      showReactivationButton
                        ? <Button
                            size={ButtonSize.small}
                            marginButton='0 16px'
                            textProps={{ spacing: '0 8px' }}
                            onHandleClick={() => setOpen(true)}
                            variation={ButtonVariation.secondary}
                            label={Text.buttons.reactivation}
                          />
                        : null
                    }
                  </>
                  )
                : (
                  <>
                    <CartLink />
                    <Link
                      title={Text.links.pricing}
                      handleClick={() => goToLink(PricingPath)}
                      path={PricingPath}
                      active={pathname.includes(PricingPath)}
                    />
                    <Link
                      title={Text.links.offers}
                      handleClick={() => window.open(decorateUrl(isAlgeria ? ExternalAlphormPages.AlgerianBusinessOffer : ExternalAlphormPages.BusinessOffer), '_blank')}
                      path={decorateUrl(isAlgeria ? ExternalAlphormPages.AlgerianBusinessOffer : ExternalAlphormPages.BusinessOffer)}
                    />
                    {
                      isFrance
                        ? <Link
                            title={Text.links.funding}
                            handleClick={() => window.open(decorateUrl(ExternalAlphormPages.Funding), '_blank')}
                            path={decorateUrl(ExternalAlphormPages.Funding)}
                          />
                        : null
                    }
                    <Link
                      title={Text.links.blog}
                      handleClick={() => window.open(decorateUrl(ExternalAlphormPages.Blog), '_blank')}
                      path={decorateUrl(ExternalAlphormPages.Blog)}
                    />
                    <Button
                      size={ButtonSize.small}
                      onHandleClick={() => {
                        signin()
                        isElligableForTrial && setTrialState(true)
                      }}
                      variation={isElligableForTrial ? ButtonVariation.confirmation : ButtonVariation.secondary}
                      label={isElligableForTrial ? Text.buttons.signupTrial : Text.buttons.signup}
                      dataTest='signup-button'
                      width={isElligableForTrial ? null : 136}
                      textProps={
                        isElligableForTrial
                          ? null
                          : { fontSize: '1rem' }
                      }
                    />
                  </>
                  )
            }
          </Col>
        </Row>
      </nav>
      <ReactivateModal setOpen={setOpen} open={open} />
    </>
  )
}
